<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AwK3qI/tc-custom/9781784384692.jpg?1704585954363" alt="This image is the cover for the book Night of the Bayonets"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Night of the Bayonets
      </h1>
      <p class="bookDescription body article font2">
        <b>This fascinating account sheds light on a little-known Nazi rebellion led by Georgian prisoners-turned-soldiers in the final days of WWII.</b><br/><br/>In April of 1945, members of the Georgian Legion serving on Nazi-occupied Texel Island rose up and slaughtered their German masters. Hitler ordered reinforcements and the fighting continued well after the war’s end. In <i>Night of the Bayonets</i>, historian Eric Lee examines this remarkable uprising from its bloods origins to its grim conclusion. <br/><br/>Thousands of Georgians served in the Soviet forces during World War II. Many of those who were captured were forced to either “starve or fight” wearing Wehrmacht uniforms. But once deployed to the Netherlands, the Georgian soldiers made contact with the local Communist resistance. <br/><br/>When their moment came, the Georgians massacred some 400 German officers using knives and bayonets. Hitler’s response was swift and merciless. It was not until May 20th—12 days after the war had ended—that Canadian forces finally put an end to the slaughter.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Eric Lee
      </h2>
      
      <p class="authorDescription body article">Born in New York City, Eric Lee has been a social-democratic activist and historian for decades. He began his career working at the United Federation of Teachers and the Textile Workers Union of America, and he founded The New International Review, a quarterly journal of democratic socialist theory and analysis, in 1977.  In 1981, Lee moved to Israel, living and working on Kibbutz Ein Dor, where he began programming, and lecturing at the Givat Haviva Centre. He published his first book, Saigon to Jerusalem: Conversations with Israel’s Vietnam Veterans, in 1991.  Since then, Lee has published on a number of different topics, including The Labour Movement and the Internet (1996) and The Experiment: Georgia’s Forgotten Revolution in 2017. His most recent book is Operation Basalt : The British Raid on Sark and Hitler's Commando (The History Press).Lee is currently based in north London, working as an author, journalist and political activist.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword/Greenhill Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4c10ca21